module.exports = __webpack_public_path__ + "img/research.78a2b61d.svg";